require('jquery-countdown');
require('./count-down/count-down.scss');
var BaseViews = require('./base');
var CountDown = BaseViews.LayoutView.extend({
    template: require('./count-down/count-down.html'),
    className: 'fmcy-count-down',
    ui: {
        countDown: '.fmcy-countdown'
    },
    modelEvents: function () {
        var modelEvents = {};
        if (this.options.modelAttr) {
            modelEvents['change:' + this.options.modelAttr] = 'render';
        }

        return _.extend(
            {},
            _.result(BaseViews.LayoutView.prototype, 'modelEvents'),
            modelEvents
        );
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                countdownFinishedText: null,
                modelAttr: null,
                timestampMs: null,
                beforeStartPrefix: null,
                afterEndPrefix: null,
                elapse: false,
                formatDisplayCallback: null
            }
        );

    },
    setCountDownText: function (text) {
        this.ui.countDown.text(text);
    },
    _renderCountDown: function () {
        var self = this;
        var startTimestampMs;
        if (self.options.modelAttr) {
            if (self.options.fromRaw) {
                startTimestampMs =
                    self.options.fromRaw.call(self, self.model.get(self.options.modelAttr));
            } else {
                startTimestampMs = self.model.get(self.options.modelAttr);
            }
        } else {
            startTimestampMs = self.options.startTimestampMs;
        }

        if (!startTimestampMs) {
            return;
        }

        function getTimeString (event) {
            var timeStringArr = [];
            if (event.offset.weeks) {
                timeStringArr.push('<span>' + event.offset.weeks + '</span> weeks');
            }

            if (event.offset.days) {
                timeStringArr.push('<span>' + event.offset.days + '</span> days');
            }

            if (event.offset.hours) {
                timeStringArr.push('<span>' + event.offset.hours + '</span> hours');
            }

            if (event.offset.minutes) {
                timeStringArr.push('<span>' + event.offset.minutes + '</span> minutes');
            }

            if (event.offset.seconds) {
                timeStringArr.push('<span>' + event.offset.seconds + '</span>');
            }
            return event.strftime(timeStringArr.join(' '));
        }

        self.ui.countDown.countdown(startTimestampMs, { elapse: self.options.elapse })
        .on('update.countdown', function(event) {
            if (self.options.formatDisplayCallback) {
                $(this).html(
                    self.options.formatDisplayCallback.call(
                        self,
                        getTimeString(event),
                        event.elapsed
                    )
                );
            } else if (self.options.elapse && event.elapsed) {
                $(this).html([self.options.afterEndPrefix, getTimeString(event)].join(' '));
            } else {
                $(this).html([self.options.beforeStartPrefix, getTimeString(event)].join(' '));
            }
        }).on('finish.countdown', function () {
            self.trigger('finished');
            if (self.options.countdownFinishedText) {
                self.setCountDownText(self.options.countdownFinishedText);
            }
        });
    },
    onRender: function () {
        BaseViews.LayoutView.prototype.onRender.call(this);
        this._renderCountDown();
    }
});
module.exports = CountDown;



/** WEBPACK FOOTER **
 ** ./assets/js/common/count-down.js
 **/